import { Box, Tooltip, useTheme } from "@mui/material"
import { useTranslation } from "react-i18next"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"

import type { KeyboardEvent } from "react"

interface QualityErrorIconProps {
  onRetry?: () => void
  isRetrying?: boolean
}

const MINI_SIZE = 20

const QualityErrorIcon = ({ onRetry, isRetrying = false }: QualityErrorIconProps) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const clickable = Boolean(onRetry) && !isRetrying

  return (
    <Tooltip
      title={t("quality.QUALITY_UNAVAILABLE")}
      enterTouchDelay={0}
      placement="bottom"
      arrow
    >
      <Box
        data-testid="quality-error-icon"
        onClick={clickable ? onRetry : undefined}
        role={clickable ? "button" : undefined}
        tabIndex={clickable ? 0 : undefined}
        aria-label={clickable ? String(t("quality.QUALITY_UNAVAILABLE")) : undefined}
        onKeyDown={
          clickable
            ? (event: KeyboardEvent<HTMLDivElement>) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault()
                  onRetry?.()
                }
              }
            : undefined
        }
        sx={{
          cursor: clickable ? "pointer" : "default",
          opacity: isRetrying ? 0.5 : 1,
          display: "flex",
          alignItems: "center",
          color: theme.palette.warning.main,
          transition: "transform 0.2s ease-in-out",
          "&:hover": clickable ? { transform: "scale(1.1)" } : undefined,
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: MINI_SIZE }} />
      </Box>
    </Tooltip>
  )
}

export default QualityErrorIcon
